export interface DeleteOrderListRequest {
  id: number
  revision: number
}

export function DeleteOrderListRequestToJSON(
  value: DeleteOrderListRequest
): any {
  return {
    id: value.id ? value.id : undefined,
    revision: value.revision ? value.revision : undefined
  }
}
